import { Facebook, Instagram, Linkedin, X } from "lucide-react"

// Brand and company constants
export const COMPANY = {
  name: "Bigwin Relocation",
  tagline: "Trusted Packers and Movers for Stress-Free Shifting",
  description:
    "Experience stress-free relocation with India's most trusted moving partner. Professional packing, secure transport, and 24/7 support.",
  website: "https://bigwinrelocation.com",
  established: 2014,
}

// Contact Information
export const CONTACT = {
  // Primary Contact
  phone: {
    primary: "+918006427000",
    display: "+91-800-642-7000",
    whatsapp: "918006427000", // Without + for WhatsApp API
  },
  
  // Email Addresses
  email: {
    primary: "info@bigwinrelocation.com",
    support: "bigwinrelocation@gmail.com",
    business: "info@bigwinrelocation.com",
    complaints: "bigwinrelocation@gmail.com",
    noReply: "no-reply@bigwinrelocation.com",
  },
  
  // Office Address
  address: {
    main: "India",
    full: "Plot no 613 near Reliance fresh, in front of 5star electronics, Saheed Nagar, Bhubaneswar, Odisha 751007",
    coordinates: {
      lat: 20.287806,
      lng: 85.845337,
    },
  },
  
  // Social Media Handles
  social: {
    whatsappMessage: "Hi Bigwin Relocation! I would like to get a free quote for my move.",
  },
}

// Color scheme
export const COLORS = {
  primary: "#003DA5", // Blue
  secondary: "#FF7A00", // Orange
  background: "#FFFFFF",
  foreground: "#1A1A1A",
  muted: "#666666",
  border: "#E5E5E5",
  success: "#10B981",
  error: "#EF4444",
  warning: "#F59E0B",
}


// Navigation items
export const NAVIGATION = [
  { name: "Services", href: "/services" },
  { name: "Locations", href: "/locations" },
  { name: "Why Us", href: "/why-us" },
  { name: "FAQ", href: "/faq" },
  { name: "Contact", href: "/contact" },
  { name: "Complaint", href: "/complaint" },
  { name: "Blog", href: "/blog" },
]

// Footer Legal Links
export const LEGAL_LINKS = [
  { name: "Privacy Policy", href: "/terms" },
  { name: "Terms & Conditions", href: "/terms" },
]

// Social links
export const SOCIAL_LINKS = [
  { name: "Facebook", url: "https://www.facebook.com/share/1DQ5wyxVQk/",icon: Facebook, color: "from-blue-600 to-blue-700"},
  { name: "Twitter", url: "https://x.com/Bigwinrelocatio?t=ee9Uhit0LXkqB3vIN3HlNQ&s=09",icon:X,color: "from-gray-600 to-gray-700" },
  { name: "LinkedIn", url: "https://linkedin.com/company/bigwin-relocation",icon:Linkedin,color: "from-blue-600 to-blue-700"},
  { name: "Instagram", url: "https://www.instagram.com/bigwinrelocation?igsh=MWwwOGJoMnJpcWx6Nw==", icon: Instagram,color: "from-pink-500 to-purple-600" },
]